export default "/images/vendor/@coreui/icons/svg/flag/cif-nz.svg?63560f9ecb14ec9e5f57aeffe5e6d8ea";